var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMinusOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-minus-outlined",
    d: "M22261.15,13389.365a12,12,0,1,1,12,12A11.991,11.991,0,0,1,22261.15,13389.365Zm1.6,0a10.4,10.4,0,1,0,10.395-10.395A10.411,10.411,0,0,0,22262.752,13389.365Zm5.6.8a.8.8,0,1,1,0-1.6h9.594a.8.8,0,0,1,0,1.6Z",
    transform: "translate(-22261.15 -13377.369)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinusOutlined);
export default __webpack_public_path__ + "static/media/icon-minus-outlined.86c8bc8e15a1c0bd7225df05c4194b02.svg";
export { ForwardRef as ReactComponent };